import $ from 'jquery'

// Step 2 of the wizard, the checklist
// ---------------------------------------------------------------------
// Every check point is open at once. This counts what is answered for the
// bar at the bottom, stops a submit that leaves a required check open and
// shows which one, moves on with Enter, and lets a second tap on the chosen
// answer of an optional check clear it again.

const checklistFields = (entry) =>
  Array.from(entry.querySelectorAll('.checklist-entry-answer input, .checklist-entry-answer select, .checklist-entry-answer textarea'))
    .filter((field) => !field.disabled && field.type !== 'hidden' && field.type !== 'file')

// A photo or a file answers an optional check point on its own, such as
// "Zusatzarbeiten (mit Foto dokumentieren)". A required one still needs its
// value, which "Weiter" asks for. An upload counts once it has finished:
// direct_uploads.js then shows it as .finished-upload, as the server does
// for one attached before.
const entryAnswered = (entry) => {
  const fields = checklistFields(entry)
  const hasValue = fields.some((field) => {
    if (field.type === 'radio') return field.checked
    return field.value.trim() !== ''
  })
  if (hasValue) return true

  const attached = entry.querySelector('.checklist-entry-attachment .finished-upload') != null
  return attached && !fields.some((field) => field.required)
}

const firstInvalidField = (entry) =>
  checklistFields(entry).find((field) => !field.checkValidity())

// The control to land on: the chosen answer, else the first one visible.
// Tom Select hides the <select> it replaces behind an input of its own.
const focusTarget = (entry) =>
  entry.querySelector('.btn-check:checked') ||
    checklistFields(entry).find((field) => field.offsetParent !== null)

const scrollBehavior = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'

const updateProgress = (list) => {
  const entries = list.querySelectorAll('.checklist-entry')
  let answered = 0
  entries.forEach((entry) => {
    const isAnswered = entryAnswered(entry)
    entry.classList.toggle('is-answered', isAnswered)
    if (isAnswered) answered += 1
  })

  const progress = document.querySelector('.wizard-progress')
  if (!progress) return

  progress.querySelector('.wizard-progress-answered').textContent = answered
  progress.querySelector('.progress').setAttribute('aria-valuenow', answered)
  const share = entries.length ? answered / entries.length * 100 : 0
  progress.querySelector('.progress-bar').style.width = `${share}%`
}

const markInvalid = (entry, field, requiredMessage) => {
  entry.classList.add('is-invalid')
  const message = field.validity.valueMissing ? requiredMessage : field.validationMessage
  entry.querySelector('.checklist-entry-feedback').textContent = message
}

$(document).on('turbo:load', () => {
  const list = document.getElementById('maintenance_record_entries')
  if (!list) return

  const form = list.closest('form')
  updateProgress(list)

  const refresh = (event) => {
    updateProgress(list)
    const entry = event.target.closest('.checklist-entry')
    if (entry && !firstInvalidField(entry)) entry.classList.remove('is-invalid')
  }
  list.addEventListener('input', refresh)
  list.addEventListener('change', refresh)
  // A finished or removed upload changes the markup, not a field
  new MutationObserver(() => updateProgress(list)).observe(list, { childList: true, subtree: true })

  // Cancel and the value transfers leave without the checklist being complete
  form.addEventListener('submit', (event) => {
    if (event.submitter?.dataset.skipValidation) return

    const invalidEntries = []
    list.querySelectorAll('.checklist-entry').forEach((entry) => {
      const field = firstInvalidField(entry)
      if (!field) return

      markInvalid(entry, field, list.dataset.requiredMessage)
      invalidEntries.push(entry)
    })
    if (!invalidEntries.length) return

    event.preventDefault()
    const firstInvalid = invalidEntries[0]
    firstInvalid.scrollIntoView({ block: 'center', behavior: scrollBehavior() })
    focusTarget(firstInvalid)?.focus({ preventScroll: true })
  })

  // Enter moves on to the next check point, and from the last one to
  // "Weiter", instead of submitting the form half filled. A note keeps its
  // line breaks: there Enter is left alone, as on a phone's keyboard there is
  // no Shift to reach for. Tom Select picks its option with Enter itself.
  list.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return
    if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey || event.isComposing) return

    const field = event.target
    if (field.matches('textarea, a, button, [type="file"]') || field.closest('.ts-wrapper')) return

    const entry = field.closest('.checklist-entry')
    if (!entry) return

    event.preventDefault()
    const nextEntry = entry.nextElementSibling
    if (nextEntry) {
      focusTarget(nextEntry)?.focus({ preventScroll: true })
      nextEntry.scrollIntoView({ block: 'nearest', behavior: scrollBehavior() })
    } else {
      form.querySelector('.wizard-bar-next')?.focus()
    }
  })

  // A radio cannot be unchecked by tapping it again. For an optional check
  // that is the only way back to unanswered, so do it here.
  list.addEventListener('click', (event) => {
    const label = event.target.closest('.answer-option')
    const radio = label && document.getElementById(label.htmlFor)
    if (!(radio?.checked && !radio.required)) return

    event.preventDefault()
    radio.checked = false
    radio.dispatchEvent(new Event('change', { bubbles: true }))
  })
})

// Show when the selected checklist was last filled out
// ---------------------------------------------------------------------

$(document).on('turbo:load', () => {
  const selectTemplate = $('#maintenance_record_template_id')
  const templateLastUse = $('.maintenance_template_last_use')

  selectTemplate.on('change', () => {
    const selectedTemplateId = selectTemplate.find('option:selected').val()
    const selectedTemplateLastUse = templateLastUse.find(`#maintenance_template_last_use_${selectedTemplateId}`)
    templateLastUse.find('div').css('display', 'none')
    if (selectedTemplateLastUse.length > 0) {
      selectedTemplateLastUse.css('display', 'block')
    }
  })

  // IMPORTANT
  // Also trigger everything after page (re)load, e.g. validation fail
  selectTemplate.trigger('change')
})
